import { render, staticRenderFns } from "./ResumeUserInformation.vue?vue&type=template&id=5fe61540&scoped=true&"
import script from "./ResumeUserInformation.vue?vue&type=script&lang=js&"
export * from "./ResumeUserInformation.vue?vue&type=script&lang=js&"
import style0 from "./ResumeUserInformation.vue?vue&type=style&index=0&id=5fe61540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe61540",
  null
  
)

export default component.exports